import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFeldOptionCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostFeldOptionCommandService],
  exports: []
})
export class PostFeldOptionCommandServiceModule { }
